/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droparchived1Inputs */

const en_droparchived1 = /** @type {(inputs: Droparchived1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop archived`)
};

const de_droparchived1 = /** @type {(inputs: Droparchived1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop archiviert`)
};

/**
* | output |
* | --- |
* | "Drop archived" |
*
* @param {Droparchived1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droparchived1 = /** @type {((inputs?: Droparchived1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droparchived1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droparchived1(inputs)
	return de_droparchived1(inputs)
});
export { droparchived1 as "dropArchived" }